import { CONSTANTS } from '../../constants/constants';
import { ACR_RESOURCE_TYPE } from '../../pages/NRSettings/NRUsersAndAccess/rbac.constants';
import { RBAC_PERMISSIONS } from '../../pages/NRSettings/NRUsersAndAccess/NRRoles/NRCustomRoles/NRCustomRolePermissions.constants';

/**
 * Maps legacy call-site permission strings to RBAC catalog IDs and default resource scope.
 *
 * Ambiguous permissions (e.g. WRITE_USERS used for both user admin and notification admin)
 * should pass an explicit `rbacPermission` override at the call site.
 *
 * WRITE_TAGS has no dedicated RBAC catalog entry; tentatively mapped to assets:write at ASSET scope.
 */
const LEGACY_PERMISSION_MAP = {
  [CONSTANTS.PERMISSIONS.WRITE_IMGS]: {
    rbac: RBAC_PERMISSIONS.WRITE_ASSETS,
    resourceType: ACR_RESOURCE_TYPE.ASSET
  },
  [CONSTANTS.PERMISSIONS.WRITE_GROUPS]: {
    rbac: RBAC_PERMISSIONS.WRITE_ASSET_GROUPS,
    resourceType: ACR_RESOURCE_TYPE.ORGANIZATION
  },
  [CONSTANTS.PERMISSIONS.DELETE_GROUPS]: {
    rbac: RBAC_PERMISSIONS.WRITE_ASSET_GROUPS,
    resourceType: ACR_RESOURCE_TYPE.ASSET_GROUP
  },
  [CONSTANTS.PERMISSIONS.WRITE_USERS]: {
    rbac: RBAC_PERMISSIONS.SETTINGS_ADMINISTRATION_MANAGE,
    resourceType: ACR_RESOURCE_TYPE.ORGANIZATION
  },
  [CONSTANTS.PERMISSIONS.WRITE_ORGCONFIG]: {
    rbac: RBAC_PERMISSIONS.SETTINGS_GENERAL_MANAGE,
    resourceType: ACR_RESOURCE_TYPE.ORGANIZATION
  },
  [CONSTANTS.PERMISSIONS.WRITE_TAGS]: {
    rbac: RBAC_PERMISSIONS.WRITE_ASSETS,
    resourceType: ACR_RESOURCE_TYPE.ASSET
  }
};

const RBAC_PERMISSION_VALUES = new Set(Object.values(RBAC_PERMISSIONS));

export function isLegacyPermission(permission) {
  return Object.prototype.hasOwnProperty.call(LEGACY_PERMISSION_MAP, permission);
}

export function resolveRbacPermission(permission) {
  const mapping = LEGACY_PERMISSION_MAP[permission];
  if (mapping) {
    return mapping.rbac;
  }

  if (RBAC_PERMISSION_VALUES.has(permission)) {
    return permission;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.warn(`[permissionMapping] Unmapped permission: ${permission}`);
  }

  return null;
}

export function resolveDefaultResourceScope(permission) {
  const mapping = LEGACY_PERMISSION_MAP[permission];

  return {
    resourceType: mapping?.resourceType ?? ACR_RESOURCE_TYPE.ORGANIZATION,
    resourceId: undefined
  };
}
